module.exports = __webpack_public_path__ + "static/img/6.7de123a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/6.png
// module id = 6v+i
// module chunks = 0